import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnChanges, OnDestroy, SimpleChanges, inject, input } from '@angular/core';

import { TickerInterval, TickerService } from '@frontend/sports/common/core/utils/timer';
import { Subscription } from 'rxjs';

import { ScoreboardTimer } from '../../../../scoreboards/models/scoreboard-timer';
import { TimerUtilsService } from '../../../../timers/timer-utils.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ms-my-bets-scoreboard-timer',
    templateUrl: 'my-bets-scoreboard-timer.html',
    standalone: false,
})
export class MyBetsScoreboardTimerComponent implements OnChanges, OnDestroy {
    private changeDetector = inject(ChangeDetectorRef);
    private ticker = inject(TickerService);
    private timerUtilsService = inject(TimerUtilsService);

    vm = input.required<ScoreboardTimer>();
    private tickerSubscription: Subscription;
    timer: string;

    ngOnChanges(changes: SimpleChanges): void {
        this.stopSubscription();
        this.setTime();
        this.tickerSubscription = this.ticker.subscribe(this.setTime, TickerInterval.Second);
    }

    private stopSubscription(): void {
        this.tickerSubscription?.unsubscribe();
    }

    private setTime = () => {
        const formated = this.timerUtilsService.getEventStartingInText(this.vm().eventStartDate.getTime());

        const format = this.vm().getTimeMyBets(formated);
        if (format === this.timer) {
            return;
        }
        this.timer = format;
        this.changeDetector.detectChanges();
    };

    ngOnDestroy(): void {
        this.stopSubscription();
    }
}
